import { useEnquiryFormContext } from '@context/EnquiryFormContext'
import { Link } from '@routes'
import IconCloseCircle from '@icons/CloseCircle'
import * as S from './EnquiryFormNav.styled'

const EnquiryFormNav = ({ standalone = false, referrerUrl = '/' }) => {
  const { setShowEnquiryForm, backToPreviousPage, setBackToPreviousPage } = useEnquiryFormContext()

  const handleClose = () => {
    setShowEnquiryForm(false)
    if (backToPreviousPage) {
      setBackToPreviousPage(false)
      window?.history?.back?.()
    }
  }

  const Logo = () => {
    return (
      <S.Logo onClick={handleClose}>
        <Link route='/' passHref>
          <img src='/imgs/logo.svg' alt='Barryplant' />
        </Link>
      </S.Logo>
    )
  };

  if (standalone) {
    return (
      <S.EnquiryFormNav>
        <Logo />
        {backToPreviousPage ? (
          <S.CloseButton onClick={handleClose}>
            <IconCloseCircle />
          </S.CloseButton>
        ) : (
          <S.CloseButton>
            <Link route={referrerUrl} passHref onClick={handleClose}>
              <IconCloseCircle />
            </Link>
          </S.CloseButton>
        )}
      </S.EnquiryFormNav>
    )
  }

  return (
    <S.EnquiryFormNav>
      <Logo />
      <S.CloseButton onClick={handleClose}>
        <IconCloseCircle />
      </S.CloseButton>
    </S.EnquiryFormNav>
  )
}

export default EnquiryFormNav
